import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import { ReactComponent as CoinInfoIcon } from "../../../images/svgs/icons/coininfo.svg";
import { ReactComponent as ToggleIcon } from "../../../images/svgs/icons/toggle.svg";
import { ReactComponent as ToggleClose } from "../../../images/svgs/icons/cross.svg";
import NotificationPopover from './notificationPopover';
import UserInfoPopover from "./usersInfoPopover";
import ToggleNavbar from "./toggleNav";
import IconTransition from "../../ReusableComponents/TransitionIcon";
import styles from "./styles.module.css";

const Navbar = ({ coinValue, coinName }) => {
  const [toggle, setToggle] = useState(false);

  const NavLinks = () => (
    <div className={styles.navlinks}>
      <NavLink exact to="/dashboard" activeClassName={styles.active}><span>Dashboard</span></NavLink>
      <NavLink exact to="/wallet" activeClassName={styles.active}><span>Wallet</span></NavLink>
      <NavLink exact to="/mining" activeClassName={styles.active}><span>Mining</span></NavLink>
      <NavLink exact to="/trade" activeClassName={styles.active}><span>Trade</span></NavLink>
    </div>
  )
  const CoinInfo = () => (
    <div className={styles.coinInfoBox}>
      <CoinInfoIcon />
      <p>{coinValue} {coinName}</p>
    </div>
  )
  return (
    <div className={styles.navbar}>
      <div className="wrapper">
        <div className={styles.container}>
          <div className={styles.brand}>
            <NavLink to="/"><h1>Currency</h1></NavLink>
          </div>
          {NavLinks()}
          <div className={styles.actions}>
            {CoinInfo()}
            <div className={styles.notification}>
              <NotificationPopover />
            </div>
            <div className={styles.userInfo}>
              <UserInfoPopover />
            </div>
            <div className={styles.toggle} onClick={() => setToggle(!toggle)}>
              {toggle ? <IconTransition Icon={ToggleClose} /> : <ToggleIcon />}
              <ToggleNavbar toggle={toggle}>
                {NavLinks()}
                {CoinInfo()}
              </ToggleNavbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Navbar;